import { keyBy } from 'lodash';

export const classNamesOptions = [
  {
    text: 'ROI',
    value: 'roi',
  },
  {
    text: 'ROI for inference',
    value: 'roi-for_inference',
  },
];

export const defaultDynamicOption = {
  text: 'dynamic_v2_th05_x2',
  value: 'dynamic_v2_th05_x2',
  details:
    '[advised] Dynamic with better overdetection/underdetection balance (filters out "weak" cell candidates and "small" tumor cell candidates)',
};

export const dynamicCellDetectionConfigOptions = [
  {
    text: 'Non-dynamic',
    value: 'Non-dynamic',
    details: 'The legacy detection method, needs parameters created during "optimize parameters" step',
  },
  {
    text: 'dynamic_v1',
    value: 'dynamic_v1',
    details: 'Vanilla version of dynamic',
  },
  {
    text: 'dynamic_v2_solid_th0_x2 (legacy)',
    value: 'dynamic_v2_solid_th0_x2',
    details: 'Dynamic v2 with high sensitivity',
  },
  {
    text: 'dynamic_small_cells',
    value: 'dynamic_small_cells',
    details: 'Dymanic with better small cell detection',
  },
  defaultDynamicOption,
];

export const clearMlMachineTypeOptions = [
  {
    text: 'Spot',
    value: 'spot',
  },
  {
    text: 'On demand',
    value: 'on_demand',
  },
];

export interface ModelType {
  text: string;
  value: string;
  apiModelValue: string;
}

// apiModelValue according to algo/src/primitives/schemas/models.py
export const modelTypeArea: ModelType = {
  text: 'Area',
  value: 'area',
  apiModelValue: 'model_areas',
};

export const modelTypeCell: ModelType = {
  text: 'Cell',
  value: 'cell',
  apiModelValue: 'model_points',
};

export const modelTypeDefect: ModelType = {
  text: 'Defect',
  value: 'defect',
  apiModelValue: 'model_defects',
};

export const modelTypeTsm: ModelType = {
  text: 'TSM',
  value: 'tsm',
  apiModelValue: 'model_tsm',
};

export const modelTypeTls: ModelType = {
  text: 'TLS',
  value: 'tls',
  apiModelValue: 'model_tls',
};

export const modelTypeNormalization: ModelType = {
  text: 'Normalization',
  value: 'normalization',
  apiModelValue: 'model_mplex_normalization',
};

export const modelTypeClassification: ModelType = {
  text: 'Classifications',
  value: 'classification',
  apiModelValue: 'model_classification',
};
export const modelTypeNucleiSegmentation: ModelType = {
  text: 'Nuclei Segmentation',
  value: 'nucleiSegmentation',
  apiModelValue: 'model_nuclei_segmentation',
};

export const modelTypeBinaryClassifier: ModelType = {
  text: 'Binary Classifier',
  value: 'binaryClassifier',
  apiModelValue: 'model_mplex_binary_classification',
};

export const modelTypeTissueSegmentationMask: ModelType = {
  text: 'Tissue Segmentation Mask',
  value: 'tissueSegmentationMask',
  apiModelValue: 'model_tsm',
};

export const modelTypeCellSegmentation: ModelType = {
  text: 'Cell Segmentation',
  value: 'cellSegmentation',
  apiModelValue: 'model_cell_segmentation',
};

export const modelTypeCellClassification: ModelType = {
  text: 'Cell Classification',
  value: 'cellClassification',
  apiModelValue: 'model_classification',
};

export const modelTypeRunInferenceOptions: ModelType[] = [modelTypeArea, modelTypeCell, modelTypeDefect];
export const modelTypeOptions = [
  modelTypeArea,
  modelTypeCell,
  modelTypeDefect,
  modelTypeTsm,
  modelTypeTls,
  modelTypeClassification,
  modelTypeNucleiSegmentation,
  modelTypeBinaryClassifier,
  modelTypeCellSegmentation,
  modelTypeCellClassification,
  modelTypeTissueSegmentationMask,
];

export const modelTypesByValue = keyBy(modelTypeOptions, 'value');
export const modelTypesByApiModelValue = keyBy(modelTypeOptions, 'apiModelValue');
